import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { IconCheck } from '@tabler/icons-react';

import { checkUserPanelAccess } from 'helpers/dashboard';
import { handleNavigateInsightPage } from 'helpers/dashboard';
import { userSiteActions } from 'pages/dashboard/containers/sites/actions/userSites';

const UserSiteVerticalView = (props) => {
  const { site, userSelectedSite, useSiteLength, dispatch } = props;
  const history = useHistory();
  const selected = userSelectedSite.includes(site.slug);

  const handleNavigate = async (event) => {
    event.stopPropagation();
    handleNavigateInsightPage(dispatch, site, history, useSiteLength);
  };

  const handleSelectedSites = (event) => {
    if (checkUserPanelAccess(site.user_panel_role)) {
      dispatch(
        userSiteActions.UpdateSelectedSites({
          removedSelectedSite: userSelectedSite.includes(site.slug),
          data: site.slug
        })
      );
    }
  };

  return (
    <div className={`slide-card ${selected ? 'card-selected' : ''}`} onClick={handleSelectedSites}>
      <div className="card-text">
        <div className="site-name">
          {site.slug !== 'all' && checkUserPanelAccess(site.user_panel_role) && (
            <div className={`checkbox ${selected ? 'checked' : ''}`}>
              <IconCheck stroke={1.5} />
            </div>
          )}
          <h2 className="site-title">{site.slug}</h2>
        </div>
        {site.user_panel_role !== 'panel_user' && site.slug !== 'all' && (
          <Button variant="link" size="sm" className="p-0" onClick={handleNavigate}>
            view site panel
          </Button>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const useSiteLength = state.USER_SITES.user_site?.length || 0;
  return {
    userSelectedSite: state.USER_SITES.selected_sites,
    useSiteLength: useSiteLength
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

const ConnectedUserSiteVerticalView = connect(mapStateToProps, mapDispatchToProps)(UserSiteVerticalView);
export default ConnectedUserSiteVerticalView;
